// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1dgnx","selected":"Chip_selected__3f8a8"};